import { USER_SCREENS_ACCESS } from "./constant";

export const getUserScreenAccess = (data) => {
    return {
        type: USER_SCREENS_ACCESS,
        data:data
      };
  };